import { render, staticRenderFns } from "./HotelBasic.vue?vue&type=template&id=7068c569&scoped=true&"
import script from "./HotelBasic.vue?vue&type=script&lang=js&"
export * from "./HotelBasic.vue?vue&type=script&lang=js&"
import style0 from "./HotelBasic.vue?vue&type=style&index=0&id=7068c569&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068c569",
  null
  
)

export default component.exports